var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['card', 'binds-py-2', 'binds-px-3', (_vm.linear ? 'linear' : ''), (_vm.table ? 'table' : '')]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }